"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationUserRole = void 0;
var OrganizationUserRole;
(function (OrganizationUserRole) {
    OrganizationUserRole["OWNER"] = "OWNER";
    OrganizationUserRole["ADMIN"] = "ADMIN";
})(OrganizationUserRole = exports.OrganizationUserRole || (exports.OrganizationUserRole = {}));
